<template>
    <div class="beneficiario-importacao-filtro-2">
        <ToogleFilterBox classString="mx-4 px-0" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
            <div class="row m-0 w-100 mb-2">
                <b-form-group label="Nome" label-for="nome" class="input-35-filter-cases">
                    <b-form-input id="nome" placeholder="Digite aqui" v-model="form.nome" trim></b-form-input>
                </b-form-group>

                <b-form-group label="CPF" label-for="cpf" class="input-25-filter-cases">
                    <b-form-input id="cpf" placeholder="xxx.xxx.xxx-xx" 
                    v-model="form.cpf" v-mask="['###.###.###-##']" trim></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" label="Tipo:" label-for="tipo" class= "input-25-filter-cases">
                    <b-form-select id="tipo" v-model="form.tipo" :options="tipoOptions"></b-form-select>
                </b-form-group>

                <b-form-group label="Status" label-for="status" class="input-15-filter-cases">
                    <b-form-select id="status" v-model="form.status" :options="statusOptions"></b-form-select>
                </b-form-group>
            </div>
        </ToogleFilterBox>
    </div>
</template>

<script>
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";
import { mask, tokens } from 'vue-the-mask'
import Validations from '@/util/Validations'

export default {
    name: "BeneficiarioImportacaoFiltro",
    components: {
        ToogleFilterBox
    },
    directives: {mask, tokens},
    data(){
        return {
            form : {
                cpf : null,
                nome : null,
                tipo: null,
                status: 'INVALID'
            },
            statusOptions : [
                { value: null, text: '(Selecione)'},
                { value: 'INVALID', text: 'Inválido'},
                { value: 'PRE_IMPORTING', text: 'Validado' },
                { value: 'UPDATED', text: 'Alterado' }
            ],
            tipoOptions : [
            { value: null, text: '(Selecione)'},
            { value: 'TITULAR',  text:'Titular'},
            { value: 'DEPENDENTE' , text: 'Dependente'},
        ]
        }
    },
    methods: {
        filter() {
            if( Validations.isEmpty(this.form) ) {
                this.$emit("filter", {} )    
            }
            else {
                let form = {
                    ...this.form,
                    cpf: this.form.cpf && this.form.cpf.replaceAll("-","").replaceAll(".","") || null,
                    name: this.form.name && this.form.name.toUpperCase() || null
                }

                this.$emit("filter", form)
            }           
		},
        resetFilter(){
            for (let key in this.form)
            {
                this.form[key] = null
            }
        },
    },
    created() {
        this.filter()
    }
}

</script>

<style scoped>

#checkboxFilterCases {
    display: none;
}

input, select {
    font-size: 14px !important;
}

#checkboxFilterCases:checked ~ .form-filter-cases {
    /* height: 0px; */
    padding: 0px;
    overflow: hidden;
}

.icon-chevron-down {
    margin-left: 10px;
    transition: 0.2s;
    font-size: 14px !important;
}

#checkboxFilterCases:checked ~ label {
    border-radius: 10px;
    transition-delay: 0.2s;
}

#checkboxFilterCases:checked ~ label .icon-chevron-down {
    transform: rotate(180deg);
}

.label-filter-cases {
    width: 100%;
    height: 45px;
    color: #002677 !important;
    font-weight: bold !important;
    background-color: #D9F6FA;
    display: flex;
    align-items:center;
    justify-content:flex-start;
    padding: 4px !important;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.form-filter-cases {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    justify-content: flex-end;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-filter-cases input, .form-filter-cases select {
    border: 1px solid #bbbec0 !important;  
}

.input-100-filter-cases{
    width: calc(100% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-20-filter-cases {
    width: calc(20% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-40-filter-cases {
    width: calc(40% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-25-filter-cases {
    width: calc(25% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-35-filter-cases {
    width: calc(35% - 20px);
    margin: 0px 10px 10px 10px;
}

.input-15-filter-cases {
    width: calc(15% - 20px);
    margin: 0px 10px 10px 10px;
}
.form-filter-cases, .form-filter-cases-flex  {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.beneficiario-importacao-filtro {
    border: 1px solid lightgray !important;
    border-radius: 10px 10px 10px 10px;
    margin-bottom: 10px;
}

.form-filter-cases-flex {
    justify-content: flex-end;
}

@media (max-width: 620px) {
    .input-20-filter-cases, .input-40-filter-cases, .input-15-filter-cases, .input-35-filter-cases, .input-25-filter-cases{
        width: calc(100% - 20px);
    }
}

@media (max-width: 930px) {
    .label-filter-cases{
        border-radius: 0px;
    }

    #checkboxFilterCases:checked ~ label{
        border-radius: 0px;
    }

    .listing-cases{
        border-radius: 0px;
    }
}


</style>